<script lang="ts" setup>
// Properties
import ButtonSecondary from "~/components/ButtonSecondary.vue";

const props = defineProps({
    prices: {
        type: Object,
    },
});

// Data
// TODO: Chart of standards to be pull from test questions or we need to create a new field in the resource level?
const chartOfStandards = ref([
    {
        standard:
            "<b>S4E1.</b> Obtain, evaluate, and communicate information to compare and contrast the physical attributes of tars and planets.",
        chapter: "2,3,4,5,6",
        pretest: "1,25,30,32,34a,34b",
        posttest: "44,67,75",
        showMore: false,
    },
    {
        standard:
            "<b>S4E2.</b> Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec quis nunc sodales.",
        chapter: "2,3,4,5,6",
        pretest: "1,25,30,32,34a,34b",
        posttest: "44,67,75",
        showMore: false,
    },
    {
        standard:
            "<b>S4E3.</b> Quisque finibus sapien et erat hendrerit, vel tristique dui sollicitudin. Aenean sed lectus faucibus augue volutpat malesuada. Mauris ac justo ligula.",
        chapter: "2,3,4,5,6",
        pretest: "1,25,30,32,34a,34b",
        posttest: "44,67,75",
        showMore: false,
    },
    {
        standard:
            "<b>S4E4.</b> Curabitur ac erat leo. Pellentesque turpis quam, dictum eu sodales et, feugiat non sapien. Vestibulum bibendum suscipit odio, vel sodales eros convallis vel.",
        chapter: "2,3,4,5,6",
        pretest: "1,25,30,32,34a,34b",
        posttest: "44,67,75",
        showMore: false,
    },
    {
        standard:
            "<b>S4E5.</b> Vivamus ac libero eget enim imperdiet convallis id in erat. Duis at urna vitae elit pretium ultrices id sit amet mauris.",
        chapter: "2,3,4,5,6",
        pretest: "1,25,30,32,34a,34b",
        posttest: "44,67,75",
        showMore: false,
    },
    {
        standard:
            "<b>S4E6.</b> Nunc tempor quam eget sem tempus ultricies. Pellentesque elementum quam euismod aliquet commodo.",
        chapter: "2,3,4,5,6",
        pretest: "1,25,30,32,34a,34b",
        posttest: "44,67,75",
        showMore: false,
    },
]);

const showMore = ref(false);
</script>

<template>
    <div>
        <p class="mb-10 hidden lg:block">
            Donec quis purus id odio maximus elementum tincidunt id lectus. Class aptent taciti sociosqu ad litora
            torquent per conubia nostra, per inceptos himenaeos. Fusce justo risus, vulputate sed mi mattis, aliquam
            laoreet lorem. Phasellus eu leo non orci fringilla tincidunt.
        </p>

        <div class="hidden grid-cols-12 py-1 font-bold lg:grid">
            <div class="col-span-6">Standard</div>
            <div class="col-span-2 px-4">Chapter</div>
            <div class="col-span-2 px-4">Pretest Questions</div>
            <div class="col-span-2 px-4">Posttset Questions</div>
        </div>
        <div :class="showMore ? '' : 'overflow-hidden lg:max-h-40 lg:max-h-60'">
            <div
                v-for="obj in chartOfStandards"
                class="border-b border-gray-300 py-4 text-sm last:border-b-0 lg:border-b-0 lg:py-0"
            >
                <div class="grid-cols-12 lg:grid" :class="obj.showMore ? '' : 'max-h-10 overflow-hidden lg:max-h-full'">
                    <div
                        class="col-span-6 border-gray-300 leading-tight lg:border-t lg:border-r lg:py-2 lg:pr-4"
                        v-html="obj.standard"
                    ></div>
                    <div class="col-span-2 mt-2 border-gray-300 lg:mt-0 lg:border-t lg:border-r lg:px-4 lg:py-2">
                        <b class="mr-2 text-black lg:hidden">Chapter:</b>{{ obj.chapter }}
                    </div>
                    <div class="col-span-2 border-gray-300 lg:border-t lg:border-r lg:px-4 lg:py-2">
                        <b class="mr-2 text-black lg:hidden">Pretest Questions:</b>{{ obj.pretest }}
                    </div>
                    <div class="col-span-2 border-gray-300 lg:border-t lg:py-2 lg:pl-4">
                        <b class="mr-2 text-black lg:hidden">Posttest Questions:</b>{{ obj.posttest }}
                    </div>
                </div>
                <div class="text-abc-blue mt-1 lg:hidden">
                    <span v-if="!obj.showMore" class="cursor-pointer" @click="obj.showMore = true">Show more</span>
                    <span v-else class="cursor-pointer" @click="obj.showMore = false">Show less</span>
                </div>
            </div>
        </div>

        <ButtonSecondary v-if="!showMore" class="mt-6 hidden lg:inline" py="py-1" @click="showMore = true"
            >Show More</ButtonSecondary
        >
        <ButtonSecondary v-else class="mt-6 hidden lg:inline" py="py-1" @click="showMore = false"
            >Show Less</ButtonSecondary
        >
    </div>
</template>

<style scoped></style>
